import React from "react";
import { Link, useLocation } from "react-router-dom";
import colsed from "../../assets/images/xmark-solid.svg";
import { useAuth } from "../../hooks/customers/AuthProvider";
import { useTranslation } from "react-i18next";
import CartLink from "./Cart";
import * as Config from "../../config/config";

function Navigation(props) {
  const { t } = useTranslation();
  const location = useLocation(); // Get the current location

  const auth = useAuth();
  const handleLogout = () => {
    auth.logOut(); // Clear session and navigate to the default page
  };

  const customer = auth?.customer;

  return (
    <nav className={props.active ? "navigations active" : "navigations"}>
      <Link to="#" onClick={props.menuClick}>
        <img src={colsed} className="colsed" alt="close" />
      </Link>

      <div className="nav_ul">
        <Link
          to="/landing"
          className={location.pathname === "/landing" ? "active" : ""}
        >
          {t("home")}
        </Link>
        {customer?.role != Config.DISTRICT_MANAGER_ROLE && (
          <>
            <Link
              to="/favourites"
              className={location.pathname === "/favourites" ? "active" : ""}
            >
              {t("favs")}
            </Link>
            <Link
              to="/menu"
              className={location.pathname === "/menu" ? "active" : ""}
            >
              {t("menu")}
            </Link>
            <CartLink />
            <Link
              to="/bill"
              className={location.pathname === "/bill" ? "active" : ""}
            >
              {t("order")}
            </Link>
            <Link
              to="/delivered"
              className={location.pathname === "/#" ? "active" : ""}
            >
              {t("delivered")}
            </Link>
          </>
        )}
        <Link
          to="/accountmanagement"
          className={location.pathname === "/accountmanagement" ? "active" : ""}
        >
          {t("account")}
        </Link>
        {customer?.role == Config.DISTRICT_MANAGER_ROLE && (
          <Link
            to="/district-manager/pending-orders"
            className={
              location.pathname === "/district-manager/pending-orders"
                ? "active"
                : ""
            }
          >
            {t("order_approvals")}
          </Link>
        )}
        {/* {customer?.role == Config.HQ_CUSTOMER_ROLE && (
          <Link
            to="/hqreport"
            className={
              location.pathname === "/hqreport"
                ? "active"
                : ""
            }
          >
            HQ BILLING REPORT
          </Link>
        )} */}
        {/* <Link to="/#" className={location.pathname === "/#" ? "active" : ""}>{t('hqdashboard')}</Link> */}
        <Link to="/" onClick={handleLogout}>
          {t("logout")}
        </Link>
      </div>
    </nav>
  );
}

export default Navigation;
